export default __webpack_public_path__ + "static/media/schoenL.78068ff8.jpg";